module.exports = __webpack_public_path__ + "static/img/a104.449cb55f.png";